



















import { Component, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import Form from '@/mixins/form'
import { LocalStorageKeys } from '@/constants/localStorage'

export type FormPayload = {
  content: string
}

@Component({
  components: {
    TextareaInput: () => import('@/components/common/inputs/TextareaInput.vue')
  }
})
export default class CommentForm extends mixins(Form) {
  inputText = ''

  @Watch('inputText')
  onCommentChange(val: string) {
    this.draft = val
  }

  get draft() {
    const draft =
      sessionStorage.getItem(LocalStorageKeys.SCHEDULE_COMMENT_DRAFT) || ''
    return draft
  }

  set draft(val: string) {
    sessionStorage.setItem(LocalStorageKeys.SCHEDULE_COMMENT_DRAFT, val)
  }

  created() {
    this.inputText = this.draft
  }

  handleSubmit() {
    if (this.validator.hasAnyError()) {
      return
    }
    sessionStorage.removeItem(LocalStorageKeys.SCHEDULE_COMMENT_DRAFT)
    this.$emit('submit', {
      content: this.inputText
    })
  }
}
